import { convertQueryStringToQueryObject } from "utils/queryString";

export const getRefCodeFromQuery = () => {
    const hasWindow = typeof window !== "undefined";

    if (hasWindow) {
        const queryObject = convertQueryStringToQueryObject(location.search);

        return queryObject.code;
    }
};

export const getReferralSourceFromQuery = () => {
    const hasWindow = typeof window !== "undefined";

    if (hasWindow) {
        const queryObject = convertQueryStringToQueryObject(location.search);

        return queryObject.referral_source;
    }
};

export const getCityFromQuery = () => {
    const hasWindow = typeof window !== "undefined";

    if (hasWindow) {
        const queryObject = convertQueryStringToQueryObject(location.search);

        return queryObject.city;
    }
};
